import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import PaymentLoader from "../global/PaymentLoader";

const PaymentStatus = () => {
  const { merchantTransactionId } = useParams();
  const [transactionData, setTransactionData] = useState(null);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchTransactionData = async () => {
      try {
        const response = await axios.get(
          `https://api-tnnfnekj6a-uc.a.run.app/payment/redirect-url/${merchantTransactionId}`
        );

        setTransactionData(response.data.data);
      } catch (err) {
        console.error("Error fetching transaction data:", err);
        setError(err.response?.data?.error || "An unexpected error occurred.");
      }
    };

    if (merchantTransactionId) {
      fetchTransactionData();
    }
  }, [merchantTransactionId]);

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  if (!transactionData) {
    return (
      <div
        className="loading"
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <PaymentLoader />
      </div>
    );
  }

  return (
    <div className="transaction-details" style={{ padding: "20px" }}>
      <h3>Payment Status</h3>
      <div
        style={{
          border: "1px solid #ddd",
          padding: "15px",
          borderRadius: "8px",
          background: "#f9f9f9",
        }}
      >
        <p>
          <strong>Payment ID :</strong> &nbsp;&nbsp;&nbsp;{" "}
          {transactionData.merchantTransactionId}
        </p>
        <p>
          <strong>Amount :</strong> &nbsp;&nbsp;&nbsp;₹
          {(transactionData.amount / 100).toFixed(2)}
        </p>
        <p>
          <strong>Payment State :</strong>&nbsp;&nbsp;&nbsp;{" "}
          {transactionData.state}
        </p>
        <p>
          <strong>Response Code :</strong> &nbsp;&nbsp;&nbsp;
          {transactionData.responseCode}
        </p>

        <p>
          <strong>Transaction ID :</strong>&nbsp;&nbsp;&nbsp;{" "}
          {transactionData.transactionId}
        </p>
      </div>
      <p style={{ fontSize: "12px", marginTop: "10px", textAlign: "center" }}>
        * please take a screen shot for further enquires
      </p>
    </div>
  );
};

export default PaymentStatus;
